export const bannerSelector = state => (state.administration.banner.data.pagedCollection);
export const bannerTotalPages = state => (state.administration.banner.data.totalPages);
